import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  const footerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
  };

  const presenceLinks = [
    { name: "Hansraj College", href: "/hrc" },
    { name: "Ramjas College", href: "/rjc" },
    { name: "JC Bose University", href: "/jcbust" },
    { name: "Campus Law Centre", href: "/clc" },
    { name: "NIT Patna", href: "/nitp" },
    { name: "Chandigarh University", href: "/cu" },
    { name: "Panjab University", href: "/pu" },
    { name: "Lovely Professional University", href: "/lpu" },
    { name: "Faculty of Technology", href: "/fot" },
    { name: "Cluster Innovation Centre", href: "/cic" },
    { name: "Kirori Mal College", href: "/kmc" },
    { name: "Miranda House College", href: "/mhc" },
    { name: "Daulat Ram College", href: "/drc" }
  ];
  const discoverLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Activities", href: "/activities" },
    { name: "Camps", href: "/camps" },
    { name: "Chapters", href: "/chapters" },
    { name: "Valumni", href: "/valumni" }
  ];

  return (
    <footer className="footer" ref={ref}>
      <motion.div
        className="footer-container"
        variants={footerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.div className="footer-column" variants={itemVariants}>
          <h3 className="footer-title">Ethiccraft Club</h3>
          <p className="contact-info"><FaMapMarkerAlt />House No. 28, Block UA, Jawahar Nagar, Opposite Hansraj Boys Hostel, New Delhi 110007</p>
          <p className="contact-info"><FaPhoneAlt /> +91 88608 30455</p>
          <p className="contact-info"><FaEnvelope /> info@ethiccraft.com</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/ethiccraft_org" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://youtube.com/@EthiccraftClubOfficial" aria-label="YouTube"><FaYoutube /></a>
          </div>
        </motion.div>

        <motion.div className="footer-column" variants={itemVariants}>
          <h3 className="footer-title">Our Presence</h3>
          <ul className="footer-links two-column-list">
            {presenceLinks.reduce((rows, item, index) => {
              if (index % 2 === 0) {
                rows.push([item, presenceLinks[index + 1]]);
              }
              return rows;
            }, []).map((pair, rowIndex) => (
              <li key={rowIndex} className="link-pair-row">
                {pair.map((link, colIndex) => (
                  link ? (
                    <a key={colIndex} href={link.href} className="link-pair">{link.name}</a>
                  ) : null
                ))}
              </li>
            ))}
          </ul>
        </motion.div>
      </motion.div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Ethiccraft Club. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;